<template>
  <draft-form />
</template>

<script>
import DraftForm from './Form'
export default {
  name: 'Edit',
  components: { DraftForm },
  metaInfo () {
    return {
      title: this.$t('string.editBorrower'),
      titleTemplate: '%s | ' + process.env.VUE_APP_NAME
    }
  }
}
</script>

<style scoped>

</style>
